import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { Location } from '@angular/common';
import { MessageService, ConfirmationService } from 'primeng/api';
import { AdministradorService } from 'src/app/services/administrador.service';
import { RedimirSupervisor } from 'src/app/models/redimir.interface';
import { environment } from 'src/environments/environment';
import { CANJE } from 'src/app/shared/constantes/constants';

@Component({
    selector: 'app-redimir-supervisor-vista',
    templateUrl: './redimir-supervisor-vista.component.html',
    styleUrls: ['./redimir-supervisor-vista.component.scss'],
    providers: [ConfirmationService, MessageService]
})
export class RedimirSupervisorVistaComponent implements OnInit {
    readonly urlbase = environment.urlbase;
    idRedimir!: string;
    idArchivo: number | null = null;
    redeemForm: FormGroup;
    redimir!: RedimirSupervisor;
    archivoSeleccionado: File | null = null;
    showModal = false;
    modalTitle = '';
    modalMessage = '';
    accionPendiente: 'cancelar' | 'eliminar' | null = null;
    statusCanje: string[] = [...CANJE];

    get redimirFrm() {
        return this.redeemForm.controls;
    }
    get cantidad(): number {
        return this.redimir.casosclinicos.reduce((accumulator, item) => accumulator + item.e_puntos, 0);
    }
    constructor(private fb: FormBuilder,
        private administradorService: AdministradorService,
        private activedRoute: ActivatedRoute,
        private messageService: MessageService,
        private location: Location,
        private confirmationService: ConfirmationService) {

        this.idRedimir = this.activedRoute.snapshot.params['id'];
        this.redeemForm = this.createFormRedimir();
        this.obtenerInformacion(this.idRedimir);
    }

    ngOnInit(): void {
    }

    canje(id: number): string {
        return this.statusCanje[id];
    }

    obtenerInformacion(id: string): void {
        this.administradorService.getRedimirSupervisorAtender(id)
            .subscribe({
                next: (resp) => { this.redimir = resp.datos; this.fullRedimirForm(resp.datos); this.showSuccess(resp.mensaje) },
                error: (err: HttpErrorResponse) => { this.showError(err.error.message) }
            })
    }

    createFormRedimir(): FormGroup {
        return this.fb.group({
            cantidad: ['', [Validators.required, Validators.min(0)]],
            fechaFinal: ['', Validators.required],
            observacion: ['', Validators.required]
        });
    }



    fullRedimirForm(redimir: RedimirSupervisor): void {
        this.redimirFrm['cantidad'].setValue(redimir.redimir);
        this.redimirFrm['fechaFinal'].setValue(redimir.fechaFinal);
        this.redimirFrm['observacion'].setValue(redimir.observacion);
    }

    onFileSelected(event: any): void {
        const file = event.target.files[0];
        if (file) {
            const maxSize = 5 * 1024 * 1024; // 5MB
            if (file.size > maxSize) {
                this.showError('El archivo es demasiado grande. El tamaño máximo permitido es 5MB.');
                event.target.value = '';
                this.archivoSeleccionado = null;
                return;
            }
            this.archivoSeleccionado = file;
        }
    }

    onCancel(): void {
        this.accionPendiente = 'cancelar';
        this.modalTitle = 'Confirmar salir';
        this.modalMessage = '¿Está seguro que desea salir?';
        this.showModal = true;
    }

    onDestroy(id: number): void {
        if (id) {
            this.idArchivo = id;
            this.accionPendiente = 'eliminar';
            this.modalTitle = 'Confirmar Quitar Documento';
            this.modalMessage = '¿Está seguro que desea quitar el documento?';
            this.showModal = true;
        }
    }


    onSubmit(): void {


        if (this.redeemForm.valid) {
            const formData = new FormData();
            formData.append('fk_redimir', this.idRedimir);
            formData.append('observacion', this.redeemForm.get('observacion')?.value);

            // Aquí puedes agregar la lógica para enviar el formData al servidor
            this.administradorService
                .setRedimirSupervisorObservacion(formData)
                .subscribe({
                    next: (resp) => {
                        this.showSuccess(resp.mensaje);
                    },
                    error: (err: HttpErrorResponse) => { console.log(err.error.message) }
                })


        }

    }
    onUploadDocumento(): void {

        if (this.archivoSeleccionado) {
            const formData = new FormData();
            formData.append('fk_redimir', this.idRedimir);
            formData.append('documento', this.archivoSeleccionado);
            // Aquí puedes agregar la lógica para enviar el formData al servidor
            this.administradorService
                .addRedimirSupervisorDocumento(formData)
                .subscribe({
                    next: (resp) => {
                        this.redimir.referencias = resp.datos.referencias;
                        this.showSuccess(resp.mensaje);
                        this.archivoSeleccionado = null;
                    },
                    error: (err: HttpErrorResponse) => { console.log(err.error.message) }
                });

        }


    }

    eliminarArchivo(): void {
        if (this.idArchivo) {
            this.administradorService
                .quitarRedimirSupervisorDocumento(this.idArchivo)
                .subscribe({
                    next: (resp) => {
                        this.redimir.referencias = resp.datos;
                        this.showSuccess(resp.mensaje);
                        this.idArchivo = null;
                    },
                    error: (err: HttpErrorResponse) => { this.showError(err.error.message); console.log(err.error.message) }
                })

        }
    }

    confirmarAccion(): void {
        if (this.accionPendiente === 'cancelar') {
            ;
            this.location.back();
        } else if (this.accionPendiente === 'eliminar') {
            // Aquí puedes agregar la lógica para manejar el rechazo
            this.eliminarArchivo();
        }
        this.closeModal();
    }

    cancelarAccion(): void {
        this.closeModal();
    }

    closeModal(): void {
        this.showModal = false;
        this.accionPendiente = null;
    }

    resetForm(): void {
        this.redeemForm.reset();
        this.archivoSeleccionado = null;
    }

    formTieneContenido(): boolean {
        return !this.redeemForm.pristine || this.archivoSeleccionado !== null;
    }

    showSuccess(mensaje: string): void {
        this.messageService.add({
            severity: 'success',
            summary: 'Éxito',
            detail: mensaje
        });
    }

    showError(mensaje: string): void {
        this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: mensaje
        });
    }
}
